// Estimated dispatch/delivery dates (snippets/ksl-delivery-estimate.liquid).
// All calendar maths runs on the store's wall clock (UTC fields shifted by the store offset),
// so every visitor sees the same dates regardless of their own time zone.
// Helpers first: defining the element upgrades existing tags immediately.
window.KslDelivery = window.KslDelivery || {
  // "+0700" / "-0430" → minutes east of UTC
  offsetMinutes(value) {
    const match = /^([+-])(\d{2}):?(\d{2})$/.exec(value || '');
    if (!match) return -new Date().getTimezoneOffset();
    return (match[1] === '-' ? -1 : 1) * (parseInt(match[2], 10) * 60 + parseInt(match[3], 10));
  },
  formatRange(from, to) {
    const format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    if (from.getTime() === to.getTime()) return format.format(from);
    return typeof format.formatRange === 'function' ? format.formatRange(from, to) : `${format.format(from)} – ${format.format(to)}`;
  }
};

if (!customElements.get('ksl-delivery-estimate')) {
  customElements.define('ksl-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      const range = (value) => value.split(',').map((n) => Math.max(0, parseInt(n, 10) || 0));
      const [pmin, pmax] = range(this.dataset.processing || '0,0');
      const [tmin, tmax] = range(this.dataset.transit || '0,0');
      const cutoff = parseInt(this.dataset.cutoff, 10);
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const holidays = new Set((this.dataset.holidays || '').split(',').map((d) => d.trim()).filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)));

      const now = window.KSL_DELIVERY_NOW ? new Date(window.KSL_DELIVERY_NOW) : new Date(); // test hook
      const storeNow = new Date(now.getTime() + KslDelivery.offsetMinutes(this.dataset.storeOffset) * 60000);
      const iso = (d) => d.toISOString().slice(0, 10);
      const isBusinessDay = (d) => !(skipWeekends && (d.getUTCDay() === 0 || d.getUTCDay() === 6)) && !holidays.has(iso(d));
      const addBusinessDays = (date, days) => {
        const d = new Date(date);
        let left = days;
        let guard = 0;
        while (left > 0 && guard++ < 400) {
          d.setUTCDate(d.getUTCDate() + 1);
          if (isBusinessDay(d)) left--;
        }
        return d;
      };

      let start = new Date(Date.UTC(storeNow.getUTCFullYear(), storeNow.getUTCMonth(), storeNow.getUTCDate()));
      // Orders after the cut-off, or on a closed day, start on the next business day.
      if (!isBusinessDay(start) || (Number.isFinite(cutoff) && storeNow.getUTCHours() >= cutoff)) start = addBusinessDays(start, 1);

      const dispatchMin = addBusinessDays(start, pmin);
      const dispatchMax = addBusinessDays(start, Math.max(pmin, pmax));
      const from = tmax > 0 ? addBusinessDays(dispatchMin, tmin) : dispatchMin;
      const to = tmax > 0 ? addBusinessDays(dispatchMax, Math.max(tmin, tmax)) : dispatchMax;

      const target = this.querySelector('[data-ksl-delivery-dates]');
      if (!target) return;
      target.textContent = KslDelivery.formatRange(from, to);
      target.hidden = false;
      this.dataset.from = iso(from);
      this.dataset.to = iso(to);
    }
  });
}
